import { defineComponent as a, openBlock as n, createBlock as r, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconBoltDisabled",
  __name: "IconBoltDisabled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, l) => (n(), r(p(s), c(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...l[0] || (l[0] = [
        e("path", { d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06m5.301 8.462L6.464 12.75H9.59l2.754 2.754-.88 4.176 2.117-2.939 1.075 1.075-2.665 3.702c-.79 1.097-2.516.334-2.237-.988l1.321-6.28H5.976a1.25 1.25 0 0 1-1.014-1.98l1.735-2.413 1.074 1.075" }, null, -1),
        e("path", { d: "M12.009 2.481c.79-1.096 2.515-.334 2.237.989l-1.321 6.28h5.098a1.25 1.25 0 0 1 1.015 1.98l-3.494 4.853-1.075-1.075 3.067-4.258H12a.75.75 0 0 1-.735-.905l1.269-6.026L8.66 9.7 7.585 8.624l4.424-6.143" }, null, -1),
        e("path", { d: "M12 12.75a.75.75 0 0 1 .734.904l-.021.098-1.002-1.002H12" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
